var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReportDetailBlock = function SvgReportDetailBlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "reportDetailBlock_svg__a",
    width: "106%",
    height: "120%",
    x: "-3%",
    y: "-8.1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 0.5,
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    "in": "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter2",
    result: "shadowBlurOuter2",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter2",
    result: "shadowMatrixOuter2",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#E44134",
    fillRule: "nonzero",
    filter: "url(#reportDetailBlock_svg__a)",
    transform: "translate(-32 -24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m42 37.753 8.885-4.443a.769.769 0 0 1 .688 1.375l-9.23 4.615a.77.77 0 0 1-.687 0l-9.23-4.615a.769.769 0 1 1 .689-1.375zm0 4.614 8.885-4.442a.769.769 0 0 1 .688 1.375l-9.23 4.615a.77.77 0 0 1-.687 0l-9.23-4.615a.769.769 0 1 1 .689-1.375zm-9.573-12.295a.768.768 0 0 1 0-1.377l9.23-4.614a.77.77 0 0 1 .687 0l9.23 4.614a.768.768 0 0 1 0 1.377l-9.23 4.614a.77.77 0 0 1-.688 0z"
  }))));
};
export default SvgReportDetailBlock;